import React from 'react'
import './card.css'

export default function Card ({ children, ...props }) {
  return (
    <div className='bpp-card' {...props} >{children}</div>
  )
}
